import { useState, useEffect } from 'react';
import { redirectTo404 } from '@/utils';
import SEO from '@/components/utils/SEO';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/stream-series-energy-saving-calculator';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import PageLayout from '@/components/PageLayout';
import BkwEnergyCalculatorComponent from '@/components/BkwEnergyCalculator';

const DOMAIN = process.env.NEXT_PUBLIC_BKW_CALCULATOR_DOMAIN;

const siteMap = new Map<string, { lang: string }>([
    ['eu', { lang: 'en' }],
    ['de', { lang: 'de' }], // 暂时使用中文，翻译词条未回来，showcase 只有中文
    ['fr', { lang: 'fr' }],
    ['uk', { lang: 'en' }],
    ['it', { lang: 'it' }],
    ['es', { lang: 'es' }],
]);

export default function BkwEnergyCalculator() {
    const { locale } = getLocal();
    const { t } = useLang('bkwEnergyCalculator');
    const [remoteUrl, setRemoteUrl] = useState<undefined | string>(undefined);

    useEffect(() => {
        // http://localhost:3000/de/de/bkw
        const host = DOMAIN;
        const site = `/${locale}`;
        const lang = `/${siteMap.get(locale as string)?.lang ?? 'en'}`;
        const path = `/bkw?terminal=ecoflow`;
        const url = `${host}${site}${lang}${path}`;

        setRemoteUrl(url);
    }, [locale]);

    if (remoteUrl === undefined) return <></>;

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc') || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <PageLayout>
                <BkwEnergyCalculatorComponent src={remoteUrl} />
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale }: { locale: string }) {
    const whitelist = seoconfig.include;
    if (!whitelist.includes(locale)) {
        return redirectTo404();
    }

    return {
        props: {},
    };
}
